import {ScannedImage} from "./scanned-image.model";

export class DocumentOcrResult {
  sidMatched: boolean;
  sidPhotosMatched: boolean;
  extractedIdNumber: string;
  extractedNameOnId : string;
  nameMatchPercentage : number;
  masterKeyWords : string[]
  masterKeyString : string;
  scannedImages : ScannedImage[]
    extractedFields: any[];
}
